module.exports = __webpack_public_path__ + "img/CZ29045371.b8337f1e.png";